/*************************************************/
/* COUNTDOWN                                     */
/*************************************************/

export function countdown() {

    const init = function () {
        let countdownElement = $(".countdown-timer"),
            countdownYear = countdownElement.data("year"),
            countdownMonth = countdownElement.data("month"),
            countdownDay = countdownElement.data("day"),
            countdownHour = countdownElement.data("hour"),
            countdownMinute = countdownElement.data("minute");

        if (countdownElement.length > 0) {
            const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            const countdownDate = `${months[countdownMonth - 1]} ${countdownDay} ${countdownYear} ${countdownHour}:${countdownMinute}:00 GMT+0100`;
            initializeCountdown("countdown-timer", countdownDate);
        }
    };

    init();

    function getTimeRemaining(endTime) {

        var t = Date.parse(endTime) - Date.parse(new Date()),
            seconds = Math.floor((t / 1000) % 60),
            minutes = Math.floor((t / 1000 / 60) % 60),
            hours = Math.floor((t / (1000 * 60 * 60)) % 24),
            days = Math.floor(t / (1000 * 60 * 60 * 24));

        return {
            "total": t,
            "days": days,
            "hours": hours,
            "minutes": minutes,
            "seconds": seconds
        };
    }

    function initializeCountdown(id, endTime) {
        var timer = document.getElementById(id),
            daysSpan = timer.querySelector(".countdown-timer__box--days"),
            hoursSpan = timer.querySelector(".countdown-timer__box--hours"),
            minutesSpan = timer.querySelector(".countdown-timer__box--minutes");

        function updateClock() {
            const t = getTimeRemaining(endTime);

            daysSpan.innerHTML = t.days.toString();
            hoursSpan.innerHTML = t.hours.toString();
            minutesSpan.innerHTML = t.minutes.toString();

            if (t.total <= 0) {
                clearInterval(timeInterval);
            }
        }

        updateClock();
        var timeInterval = setInterval(updateClock, 1000);
    }

}